"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("../../form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CTAWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e70shzq0",
  label: "CTAWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s2uf1z",
  styles: "text-align:right;"
} : {
  name: "s2uf1z",
  styles: "text-align:right;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpX2VsZW1lbnRzL25vdGlmaWNhdGlvbnMvTm90aWZpY2F0aW9uQ1RBLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLZ0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdWlfZWxlbWVudHMvbm90aWZpY2F0aW9ucy9Ob3RpZmljYXRpb25DVEEuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICcuLi8uLi9mb3JtJztcblxuY29uc3QgQ1RBV3JhcHBlciA9IHN0eWxlZCgnZGl2JylgXG4gIHRleHQtYWxpZ246IHJpZ2h0O1xuYDtcblxuY29uc3QgTm90aWZpY2F0aW9uQ1RBID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHtcbiAgICBkZWNsaW5lQnV0dG9uTXNnLFxuICAgIGFjY2VwdEJ1dHRvbk1zZyxcbiAgICBoYW5kbGVEZWNsaW5lLFxuICAgIGhhbmRsZUFjY2VwdFxuICB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8Q1RBV3JhcHBlcj5cbiAgICAgIDxCdXR0b24gb25DbGljaz17aGFuZGxlRGVjbGluZX0+XG4gICAgICAgIHtkZWNsaW5lQnV0dG9uTXNnfVxuICAgICAgPC9CdXR0b24+XG4gICAgICA8QnV0dG9uIG9uQ2xpY2s9e2hhbmRsZUFjY2VwdH0gdmFyaWFudD1cInNlY29uZGFyeVwiPlxuICAgICAgICB7YWNjZXB0QnV0dG9uTXNnfVxuICAgICAgPC9CdXR0b24+XG4gICAgPC9DVEFXcmFwcGVyPlxuICApO1xufTtcblxuTm90aWZpY2F0aW9uQ1RBLnByb3BUeXBlcyA9IHtcbiAgZGVjbGluZUJ1dHRvbk1zZzogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBhY2NlcHRCdXR0b25Nc2c6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgaGFuZGxlRGVjbGluZTogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgaGFuZGxlQWNjZXB0OiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkXG59O1xuXG5leHBvcnQgZGVmYXVsdCBOb3RpZmljYXRpb25DVEE7XG4iXX0= */"
});

var NotificationCTA = function NotificationCTA(props) {
  var declineButtonMsg = props.declineButtonMsg,
      acceptButtonMsg = props.acceptButtonMsg,
      handleDecline = props.handleDecline,
      handleAccept = props.handleAccept;
  return _react.default.createElement(CTAWrapper, null, _react.default.createElement(_form.Button, {
    onClick: handleDecline
  }, declineButtonMsg), _react.default.createElement(_form.Button, {
    onClick: handleAccept,
    variant: "secondary"
  }, acceptButtonMsg));
};

NotificationCTA.propTypes = {
  declineButtonMsg: _propTypes.default.string.isRequired,
  acceptButtonMsg: _propTypes.default.string.isRequired,
  handleDecline: _propTypes.default.func.isRequired,
  handleAccept: _propTypes.default.func.isRequired
};
var _default = NotificationCTA;
exports.default = _default;